export const facultyMenu = [
    // {
    //     title: "Dashboard",
    //     url: "/dashboard",
    //     icon: "bi bi-grid-fill",
    // },
     {
        title: "Enquiry",
        url: "/enquiry",
        icon: "bi bi-patch-question", 
    },
    {
        title: "Batch",
        url: "/batch/list",
        icon: "bi bi-ui-checks-grid",
    },
    {
        title: "Attendance History",
        url: "/attendance/history",
        icon: "bi bi-calendar2-check",
    }
];
